import {
  Box,
  ButtonGroup,
  Drawer,
  Grid,
  IconButton,
  Popover,
  Theme,
  Tooltip,
  Typography,
  useMediaQuery,
  Zoom,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { AssignmentReturn, Cancel, Create, Info, Send } from "@material-ui/icons";
import * as React from "react";
import { FC, Fragment, useState } from "react";
import {
  BooleanField,
  BooleanInput,
  Datagrid,
  ExportButton,
  Filter,
  FilterProps,
  FunctionField,
  ListContextProvider,
  ListProps,
  ReferenceInput,
  SelectArrayInput,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
  useListContext,
  useNotify,
} from "react-admin";
import { useHistory } from "react-router-dom";
import { TabbedDatagridProps } from "src/Models/TabbedDataGridProps";
import { DetailButton } from "../../../src/Components/DetailButton";
import { useAppDataProvider } from "../../../src/dataprovider";
import { RequestStatus } from "../../../src/Enums/RequestStatus";
import ColoredTextFieldForRbh from "../../Components/ColoredTextFieldByWo/ColoredTextFieldForRbh";
import { ConfirmButton } from "../../Components/ConfirmButton";
import { DefaultPerPageSize } from "../../Constants/Constant";
import { ExcelExport } from "../../Helper/ExportExcel";
import { SourceRequestOrder } from "../RequestOrder/Components";
import RequestOrderNotes from "../RequestOrder/Components/RequestOrderNotes";
import { useStyles } from "../RequestOrder/Components/RequestOrderList/styles";
import { DashboardRbhExcelHeader, DashboardRbhExcelName } from "./ExcelRbh";
import { SourceDashboardRbh, TitleDashboardRbh } from "./Source";
import { RemarkTypes } from "../../../src/Enums/RemarkTypes";
import { useAccessControl, useAuth, useVerifyPermission } from "@airborne/react-admin";
import PoolList from "../../Components/PoolListComponent/PoolListComponent";
import CopyableTableWrapper from "../../../src/Components/CopyableTableWrapper";
import { formatDate } from "../../../src/Helper/MomentHelper";

const remaininDaysFilterArray = [
  { displayName: "Not Arrived Yet", value: -9999 },
  { displayName: "Shipped", value: -999 },
  { displayName: "0-5", value: 0 },
  { displayName: "6-10", value: 6 },
  { displayName: "11-15", value: 11 },
  { displayName: "16-20", value: 16 },
  { displayName: "21+", value: 21 },
];

const DashboardFilter: FC<Omit<FilterProps, "children">> = props => (
  <Filter {...props}>
    <TextInput label="Ref No" source="refNo__contains" alwaysOn />
    <TextInput label="Customer PO" source="customerPo__contains" alwaysOn />
    <TextInput label="Customer Code" source="customerCode__contains" alwaysOn />
    <TextInput label="Pn" source="pn__contains" alwaysOn />
    <TextInput label="Core Unit SN" source="unserviceableSn__contains" alwaysOn />
    <TextInput label="Serviceable SN" source="serviceableSn__contains" alwaysOn />
    <TextInput label="Core Unit AWB" source="unserviceableAwbChanged__contains" alwaysOn />
    <TextInput label="Serviceable AWB" source="serviceableAwbChanged__contains" alwaysOn />
    <TextInput label="Destination" source="airportCode__contains" alwaysOn />
    <ReferenceInput
      label="Request Status"
      source="requestStatus__in"
      reference={"requeststatusinfos"}
      perPage={100}
      translateChoice={false}
      alwaysOn
    >
      {/* <SelectInput
        optionText="displayName"
        optionValue="requestStatus"
        fullWidth
      /> */}

      <SelectArrayInput optionText="displayName" optionValue="requestStatus" fullWidth />
    </ReferenceInput>
    <BooleanInput label="Is Pool" source="isPool__eq" alwaysOn />
    <TextInput label="Wo" source="tTWo__eq" alwaysOn />
    <TextInput label="Ro" source="tTRo__eq" alwaysOn />
    <SelectInput
      label="Core Remaining Day(s)"
      optionText="displayName"
      optionValue="value"
      source="remainingDayDisplay__eq"
      choices={remaininDaysFilterArray}
      fullWidth
      alwaysOn
    />
  </Filter>
);

const ExportToExcelRbh = user => data => {
  var exportData = data.map(v => [
    v.refNo,
    v.customerPo,
    v.requestedDeliveryDate != null ? v.requestedDeliveryDate : "Not Arrived Yet",
    v.customerCode,
    v.repairTat,
    v.pn,
    v.unserviceableCarrier,
    v.unserviceableSn,
    v.unserviceableNotifiedDate != null
      ? v.unserviceableUpdatedDate != null && v.unserviceableUpdatedDate > v.unserviceableNotifiedDate
        ? v.unserviceableUpdatedDate
        : v.unserviceableNotifiedDate
      : "",
    v.unserviceableAwb,
    v.serviceableNotifiedDate != null ? v.serviceableNotifiedDate : "",
    v.serviceableAwb,
    v.serviceableSn,
    v.serviceable,
    v.unserviceable,
    v.isPool,
    v.airportCode,
    v.aircraft,
    v.requestDate != null ? v.requestDate : "",
    v.requestStatusText,
    v.requestRemark,
    v.unserviceableRemoveDate != null ? v.unserviceableRemoveDate : "",
    v.removeReason,
    v.unserviceableRemark,
    v.shipmentArrivedDate != null ? v.shipmentArrivedDate : "",
    v.ordinoDate != null ? v?.ordinoDate : "",
    v.replacementPendingDate != null ? v.replacementPendingDate : "",
    v.remainingDayToRdd,
    v.whCount,
    v.unserviceableRemoveReasonRemark,
    v.batch,
    v.orderNumber,
    v.ttWo,
    v.ttRo,
    v.location,
    v.roStatus,
    v.flightDate != null ? v.flightDate : "",
    v.flightNo,
    (user?.isCustomer === false && v.experienceIsShownTt === true) ||
    (user?.isCustomer === true && v.experienceIsShownCustomer === true)
      ? getText(v.experienceRemark)
      : "",
  ]);
  if (user?.isCustomer !== false) {
    exportData = exportData.map(x => {
      var row = x.filter((x, i) => {
        var column = DashboardRbhExcelHeader[i];
        if (column?.isCustomer == false) {
          return false;
        }
        return true;
      });
      return row;
    });
  }
  ExcelExport(
    user?.isCustomer === false ? DashboardRbhExcelHeader : DashboardRbhExcelHeader.filter(x => x.isCustomer != false),
    exportData,
    DashboardRbhExcelName
  );
};

// get plain text from html string
const getText = html => {
  var divContainer = document.createElement("div");
  divContainer.innerHTML = html;
  return divContainer.textContent || divContainer.innerText || "";
};

const CustomListActions = props => (
  <TopToolbar>
    <ExportButton maxResults={10000} {...props} />
  </TopToolbar>
);

const TabbedDatagrid: FC<TabbedDatagridProps> = props => {
  const listContext = useListContext();
  const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down("xs"));
  const [isMatchCreate, setIsMatchCreate] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [request, setRequest] = React.useState<any>({});
  const [xoNumber, setXoNumber] = React.useState<any>(null);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const { user } = useAuth();

  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl(SourceRequestOrder);

  const SendStatus160ButtonClick = props => e => {
    dataProvider
      .getOne("requestorders/", {
        id: props.record.id,
      })
      .then(response => {
        response.data.requestStatus = RequestStatus.CancellationRepairPeriod;
        dataProvider
          .updateRequestOrder(response.data)
          .then(result => {
            //history.push('/requestorders/' + result.data.id)
            history.go(0);
            notify(`Record Updated`, "success", false, true);
          })
          .catch(error => notify(`${error}`, "error", false, true))
          .finally(() => setLoading(false));
      })
      .catch(error => {});
  };

  const SendPreviousStatusButtonClick = props => e => {
    dataProvider
      .getList("requesthistorys/", {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "DESC" },
        filter: {
          requestId__eq: props.record.id,
          requestStatus__neq: RequestStatus.CancellationRepairPeriod,
        },
      })
      .then(response => {
        var previousRecord = response.data.sort((a, b) => a.createdDate - b.createdDate)[0];
        dataProvider
          .getOne("requestorders/", {
            id: props.record.id,
          })
          .then(response => {
            response.data.requestStatus = previousRecord.requestStatus;
            dataProvider
              .updateRequestOrder(response.data)
              .then(result => {
                //history.push('/requestorders/' + result.data.id)
                history.go(0);
                notify(`Record Updated`, "success", false, true);
              })
              .catch(error => notify(`${error}`, "error", false, true))
              .finally(() => setLoading(false));
          })
          .catch(error => {});
      })
      .catch(error => {});
  };

  const SendStatus160Button = props => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40 }}
        size="medium"
        isLoading={loading}
        click={SendStatus160ButtonClick(props)}
      >
        <Tooltip TransitionComponent={Zoom} title="Send Replacement Pending">
          <Send />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const SendPreviousStatus = props => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40 }}
        size="medium"
        isLoading={loading}
        click={SendPreviousStatusButtonClick(props)}
      >
        <Tooltip TransitionComponent={Zoom} title="Send Previous Status">
          <AssignmentReturn />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const RemarkButton = props => {
    return (
      <IconButton style={{ width: 40 }} onClick={remarkOnClick(props.record)}>
        <Tooltip TransitionComponent={Zoom} title="Core Last Update">
          <Create />
        </Tooltip>
      </IconButton>
    );
  };
  const DetailButtons = props => {
    return <DetailButton {...props} />;
  };
  const CancelButton = props => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40 }}
        size="medium"
        isLoading={loading}
        click={cancelOnClick(props)}
      >
        <Tooltip TransitionComponent={Zoom} title="Cancel Request">
          <Cancel />
        </Tooltip>
      </ConfirmButton>
    );
  };
  const Actions = props => {
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <DetailButtons {...props} resource={"requestorders"} />
          {user?.isCustomer === false && canCreate && <CancelButton {...props} />}
          {user?.isCustomer === false && canCreate && <SendStatus160Button {...props} />}
          {user?.isCustomer === false && canCreate && <RemarkButton {...props} />}
          {user?.isCustomer === false &&
            canCreate &&
            props.record.requestStatus == RequestStatus.CancellationRepairPeriod && <SendPreviousStatus {...props} />}
        </ButtonGroup>
      </Box>
    );
  };
  const remarkOnClick = props => e => {
    e.stopPropagation();
    setRequest(props);
    setIsMatchCreate(true);
  };
  const cancelOnClick = props => e => {
    dataProvider
      .getOne("requestorders/", {
        id: props.record.id,
      })
      .then(response => {
        response.data.requestStatus = RequestStatus.CancelledRequest;
        dataProvider
          .updateRequestOrder(response.data)
          .then(result => {
            history.push("/requestorders/" + result.data.id);
            notify(`Record Updated`, "success", false, true);
          })
          .catch(error => notify(`${error}`, "error", false, true))
          .finally(() => setLoading(false));
      })
      .catch(error => {});
  };
  const handleClose = () => {
    setIsMatchCreate(false);
  };
  const handleClickPopover = record => event => {
    setAnchorEl(event.currentTarget);
    setXoNumber("Loading...");
    dataProvider
      .getList("vworderheaders/", {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "DESC" },
        filter: {
          legacySystemOrderNumber__eq: record.refNo,
          orderType__eq: "XO",
        },
      })
      .then(response => {
        setXoNumber(response?.data?.[0]?.orderNumber ?? "Not Found");
      })
      .catch(error => {
        setXoNumber("Not Found");
      });
  };
  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const HtmlTooltip = withStyles(theme => ({
    tooltip: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }))(Tooltip);

  return (
    <Fragment>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography style={{ padding: "10px 20px" }}>{xoNumber}</Typography>
      </Popover>
      {isXSmall ? (
        <ListContextProvider value={{ ...listContext }}>
          <></>
        </ListContextProvider>
      ) : (
        <ListContextProvider
          value={{
            ...listContext,
          }}
        >
          <CopyableTableWrapper>
            <Datagrid hasBulkActions={false} optimized>
              <Actions label="Actions" />
              <TextField source="refNo" label="Reference Number" />
              <TextField source="ownerCode" label="Customer Code" />
              <TextField source="customerPo" label="Customer PO" />
              <FunctionField
                label="PN"
                render={record => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <TextField source="pn" label="PN" sortable={false} />
                      {((user?.isCustomer === false && record?.experienceIsShownTt === true) ||
                        (user?.isCustomer === true && record?.experienceIsShownCustomer === true)) && (
                        <Tooltip title={record?.experienceRemark}>
                          <IconButton>
                            <Info />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  );
                }}
              />
              <TextField source="repairTat" label="Repair TAT" />
              <TextField source="unserviceableSn" label="Core Unit SN" />
              <TextField source="serviceableSn" label="Serviceable SN" />
              <TextField source="unserviceableAwb" label="Core Unit AWB" />
              <TextField source="serviceableAwb" label="Serviceable AWB" />
              <BooleanField source="isPool" label="Is Pool Scope" />
              <TextField source="airportCode" label="Destination" />
              <TextField source="aircraft" label="AC-REG" sortable={false} />
              <FunctionField
                label="Remaining Day(s)"
                sortBy="clockCreatedDate"
                render={record =>
                  record?.remainingDayToRdd === -999
                    ? "Shipped"
                    : record?.requestedDeliveryDate === null
                      ? "Not Arrived Yet"
                      : record?.remainingDayToRdd
                }
                sortable={false}
              />

              <FunctionField
                label="Requested Delivery Date"
                sortBy="clockCreatedDate"
                render={record =>
                  record?.requestedDeliveryDate === null
                    ? "Not Arrived Yet"
                    : formatDate(record?.requestedDeliveryDate, false) == formatDate(new Date("01/01/9999"), false)
                      ? "Exclude"
                      : formatDate(record?.requestedDeliveryDate, false)
                }
              />

              {/* <FunctionField
              label="Shipping Type"
              render={(record) => {
                return (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center'
                    }}
                  >
                    <TextField
                      source="serviceableShippingType"
                      label="Shipping Type"
                      sortable={false}
                    />
                    {record.serviceableShippingType === 'PBH' && (
                      <IconButton onClick={handleClickPopover(record)}>
                        <Info />
                      </IconButton>
                    )}
                  </div>
                )
              }}
            /> */}
              <FunctionField
                label="Status"
                render={record => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <TextField source="requestStatusText" label="Status" sortable={false} />
                      {record?.serviceableShippingType === "PBH" && (
                        <IconButton onClick={handleClickPopover(record)}>
                          <Info />
                        </IconButton>
                      )}
                    </div>
                  );
                }}
              />
              {/* <TextField
              source="requestStatusText"
              label="Status"
              sortable={false}
            /> */}

              {user?.isCustomer === false && (
                <ColoredTextFieldForRbh source="whCount" label="Wh Count" sortable={false} />
              )}

              {user?.isCustomer === false && <ColoredTextFieldForRbh source="ttWo" label="TT-WO" sortable={false} />}
              {user?.isCustomer === false && <ColoredTextFieldForRbh source="ttRo" label="TT-RO" sortable={false} />}
              {user?.isCustomer === false && (
                <TextField
                  style={{
                    width: "100%",
                    whiteSpace: "pre-wrap",
                    lineBreak: "anywhere",
                    minWidth: 200,
                  }}
                  aria-multiline={"true"}
                  component={"pre"}
                  source="requestRemark"
                  label="Current Pbh Note"
                  sortable={false}
                />
              )}
            </Datagrid>
          </CopyableTableWrapper>

          {isMatchCreate && (
            <Grid item xs={3}>
              <Drawer
                classes={{
                  paper: classes.drawerPaper,
                }}
                variant="persistent"
                open={isMatchCreate}
                anchor="right"
                onClose={handleClose}
              >
                {isMatchCreate ? (
                  <RequestOrderNotes
                    onCancel={handleClose}
                    request={request}
                    resource="requestremarks"
                    basePath="requestremarks"
                    remarkType={RemarkTypes.PbhNote}
                  />
                ) : null}
              </Drawer>
            </Grid>
          )}
        </ListContextProvider>
      )}
    </Fragment>
  );
};
const DashboardRbh: FC<ListProps> = props => {
  useVerifyPermission("customroutes", "dashboardrbh.read");
  const { user } = useAuth();

  return (
    <PoolList
      {...props}
      resource={SourceDashboardRbh}
      basePath="dashboardrbh"
      actions={<CustomListActions />}
      perPage={DefaultPerPageSize}
      title={TitleDashboardRbh}
      exporter={ExportToExcelRbh(user)}
      filters={<DashboardFilter />}
    >
      <TabbedDatagrid />
    </PoolList>
  );
};

export default DashboardRbh;
